import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import { FormatItalic } from '@mui/icons-material';
import { expandTheme } from 'utils/theme-util';

export const FinancialAssistanceFundsStyles = theme => {
  const { font, palette } = expandTheme(theme);
  return createStyles({
    modal: {
      position: 'absolute',
      width: theme.spacing(130),
      height: theme.spacing(70),
      minHeight: theme.spacing(70),
      maxWidth: theme.spacing(130),
      backgroundColor: palette.primary.background,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(3),
      borderRadius: 5,
      overflowX: 'scroll',
    },
    title: {
      fontSize: font.extraLargeFontSize,
      fontWeight: 'bold',
      marginBottom: theme.spacing(5),
      borderBottom: `1px solid ${theme.palette.grey[200]}`,
    },
    container: {
      marginLeft: theme.spacing(5),
      marginTop: theme.spacing(5),
      marginRight: theme.spacing(5),
    },
    rowSeparator: {
      marginTop: theme.spacing(5),
    },
    advancedSearchContainer: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(5),
      border: `1px solid ${theme.palette.grey[200]}`,
      borderRadius: theme.spacing(0.5),
      padding: theme.spacing(3),
    },
    btnArea: {
      flex: 1,
      justifyItems: 'end',
      paddingTop: theme.spacing(3),
    },
    close: {
      textAlign: 'right',
    },
  });
};
